export default __webpack_public_path__ + "static/media/backgroundLogo.a0c23977.png";